import { useContext } from 'react';
import { LoadingIndicatorContext } from '../contexts/LoadingIndicator';

export const useLoadingIndicatorContext = () => {
  const loadingContext = useContext(LoadingIndicatorContext);
  return loadingContext;
}